/**
 * 地物JSONクラス
 */
export class FeatureGeoJson {
  /**
   * json
   */
  geoJson: any;

  /**
   * 地物ID
   */
  fid: string;

  /**
   * 地物JSONコンストラクタ
   * @param geoJson json
   * @param fid 地物ID
   */
  constructor(geoJson: any, fid: string) {
    this.geoJson = geoJson;
    this.fid = fid;
  }
}
